import { Button } from '@microservices/wiskey-react-components'

import { buttonStylesByMode } from '@helpers'

interface ConfiguredEntitySaveButtonProps {
  disabled: boolean
  isViewDialogWindow: boolean
  onSave: () => void
}

export const ConfiguredEntitySaveButton: React.FC<ConfiguredEntitySaveButtonProps> = props => {
  const { disabled, isViewDialogWindow, onSave: handleSave } = props

  return (
    <Button
      disabled={disabled}
      variant='outlined'
      sx={theme => ({
        ...buttonStylesByMode(theme, isViewDialogWindow),
        zIndex: 2,
        mr: 1.5,
      })}
      onClick={handleSave}
    >
      Save
    </Button>
  )
}

ConfiguredEntitySaveButton.displayName = 'ConfiguredEntitySaveButton'
